<template>
  <div>
    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="dialog2" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="dialog2 = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->
    <v-btn v-if="!yesForm" color="success" @click.native="addNew" >
      Add New
    </v-btn>
    
    <insertForm v-if="yesForm" :formSchema="formSchema" :dateValue="dateValue" v-on:emitForm="close"></insertForm>

    <v-card-title v-if="!yesForm">
      <h2>BIP Report</h2>
      <v-spacer></v-spacer>
      <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
    </v-card-title>

    <div v-if="!yesForm">
    <span style="display:none;">{{serial=serialNumber}}</span>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :pagination.sync="pagination"
      :total-items="totalDesserts"
      :loading="loading"
      class="elevation-4"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{serial++}}</td>
        <td class="text-xs-left">{{ changeFormateDMY(props.item.start_date) }}</td>
        <td class="text-xs-left">{{ changeFormateDMY(props.item.end_date) }}</td>
        <td class="justify-center layout px-0">
          <v-btn icon class="mx-0" @click="editItem(props.index, props.item)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <v-btn icon class="mx-0" @click="deleteItem(props.index, props.item.id)">
            <v-icon color="pink">delete</v-icon>
          </v-btn>          
        </td>
      </template>
    </v-data-table>
  </div>
  </div>
</template>


<script>
const commonService = require("../../../services/common.service");
import insertForm from "./insertForm";
import Axios from "axios";
import ServerPath from "../../../server-path/server-path";

export default {
  components: {
    insertForm
  },

  data: () => ({
    valid: true,
    public_path: "",
    yesForm:false,

    storeFields:{
          id: 0,
          start_date:'',
          end_date:"",

          eco_code_id: "",
          eco_account_code:"",
          eco_account_name: "", 

                 
          q1_total:"",
          q1_taka:"",
          q1_gpa:"",
          q1_rpa:"",
          q1_others:"",         
                  
          q2_total:"",
          q2_taka:"",
          q2_gpa:"",
          q2_rpa:"",
          q2_others:"",         
                 
          q3_total:"",
          q3_taka:"",
          q3_gpa:"",
          q3_rpa:"",
          q3_others:"",         
                  
          q4_total:"",
          q4_taka:"",
          q4_gpa:"",
          q4_rpa:"",
          q4_others:"",         
                 
          q5_total:"",
          q5_taka:"",
          q5_gpa:"",
          q5_rpa:"",
          q5_others:"",         
        },
    dateValue:{
      id:0,
      start_date:'',
      end_date:'',
    },

    formSchema: [
        {
          id: 0,
          start_date:'',
          end_date:"",

          eco_code_id: "",
          eco_account_code:"",
          eco_account_name: "", 

                 
          q1_total:"",
          q1_taka:"",
          q1_gpa:"",
          q1_rpa:"",
          q1_others:"",         
                  
          q2_total:"",
          q2_taka:"",
          q2_gpa:"",
          q2_rpa:"",
          q2_others:"",         
                 
          q3_total:"",
          q3_taka:"",
          q3_gpa:"",
          q3_rpa:"",
          q3_others:"",         
                  
          q4_total:"",
          q4_taka:"",
          q4_gpa:"",
          q4_rpa:"",
          q4_others:"",         
                 
          q5_total:"",
          q5_taka:"",
          q5_gpa:"",
          q5_rpa:"",
          q5_others:"",         
        },
      ], 



    /*------------- Datatable ---------------*/
    serialNumber: 0,
    sort: "",
    queryData: {
      sortBy: "id",
      descending: true,
      page: 1,
      rowsPerPage: 5,
      totalItems: 0,
      search_val: ""
    },

    search: "",
    totalDesserts: 0,
    desserts: [],
    loading: true,
    pagination: {},

    headers: [
      {
        text: "SL",
        value: ""
      },
      {
        text: "Start Date",
        align: "left",
        sortable: true,
        value: "start_date"
      },
      {
        text: "End Date",
        align: "left",
        sortable: true,
        value: "end_date"
      },
      {
        text: "Action",
        align: "center",
        sortable: false,
        value: ""
      },      
    ],
    /*------------- /Datatable ---------------*/

    delete_id: "",
    row_index: "",
    dialog2: false,
    
    SnackbarVal: {
        snackbar: false,
        color: "success",
        message: ""
      },    
  }),

  /*------------Datatable------------*/
  created() {
    
    this.public_path =
      ServerPath.serverPath + "/assets/projectInfo/yearlyProjectBudget/";
      commonService.getAllData("get-economic-codes").then(res => {
          let $this = this;
         // this.formSchema.push(this.storeFields);
          let ecoList = res.length;
          var storeFields = this.storeFields
          
          res.forEach(function(val, index){            
              storeFields.eco_code_id = val.id
              storeFields.eco_account_code = val.ecoAccount_code
              storeFields.eco_account_name = val.eco_account_name
              $this.$set($this.formSchema, index, {...storeFields });
          });

          //for(let i = 0; i<=ecoList; i++)
          //{
            //this.formSchema.push(this.storeFields)
            //this.$set(this.formSchema, i, { ...this.storeFields });
          //}
          /*ecoList.forEach(function(val){
            $this.formSchema.push($this.storeFields)
          })*/       
      });  
  },

  watch: {
    params: {
      handler() {
        this.getDataFromApi().then(data => {
          this.desserts = data.items;
          this.totalDesserts = data.total;
        });
      },
      deep: true
    }
  },

  computed: {
    params(nv) {
      return {
        ...this.pagination,
        query: this.search
      };
    }
  },
  /*------------/Datatable------------*/

  methods: {

    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        let search = this.search.trim().toLowerCase();
        
        if(search)
        {
          search = this.changeFormateYMD(search);
        }

        let query_Data = this.queryData;

        (query_Data.sortBy = "id"),
          (query_Data.descending = this.pagination.descending),
          (query_Data.page = this.pagination.page),
          (query_Data.rowsPerPage = this.pagination.rowsPerPage),
          (query_Data.search_val = search);

        const serialNumber =
          this.pagination.rowsPerPage * this.pagination.page -
          this.pagination.rowsPerPage;
        this.serialNumber = serialNumber + 1;

        commonService
          .getServerSideData(query_Data, "bip-report-list")
          .then(res => {
            let items = res.data;

            const total = res.totalRecords;
            /*if(total == 0)
            {
              this.yesForm = true;
            }*/

            if (search) {
              items = items.filter(item => {
                return Object.values(item)
                  .join(",")
                  .toLowerCase()
                  .includes(search);
              });
            }

            if (this.pagination.sortBy) {
              items = items.sort((a, b) => {
                const sortA = a[sortBy];
                const sortB = b[sortBy];

                if (descending) {
                  if (sortA < sortB) return 1;
                  if (sortA > sortB) return -1;
                  return 0;
                } else {
                  if (sortA < sortB) return -1;
                  if (sortA > sortB) return 1;
                  return 0;
                }
              });
            }

            setTimeout(() => {
              this.loading = false;
              resolve({
                items,
                total
              });
            }, 300);
          });
      });
    },

    downloadFile(fileName) {
      let url = ServerPath.serverPath+fileName;
      window.open(url);      
    },
    
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    editItem(index, item) {
            
        this.row_index = index
        //return 0;
        commonService.getAllDataById(item.id, "bip-report-details").then(res => {

          if(res.status == 1)
          {  
            this.yesForm = true;         
            this.formSchema = {...res.data};    

            this.dateValue = item            
            this.dateValue.start_date = this.changeFormateDMY(
              item.start_date
              );
            this.dateValue.end_date = this.changeFormateDMY(
              item.end_date
              );

              
          }
            
        });    
    },

    addNew(){
      this.dateValue.id = 0;            
      this.yesForm = true;
    },

    deleteItem(index, id) {
      this.row_index = index;
      this.delete_id = id;
      this.dialog2 = true;
    },

    confirmDelete(row_index, id) {
      commonService.deleteRow(id, "bip-report").then(res => {
        if (res.status == 1) {
          this.desserts.splice(row_index, 1);          
          this.SnackbarVal.color = "success"
        }
        else
        {
          this.SnackbarVal.color = "error"; 
        }
        this.SnackbarVal.message = res.message;
        this.SnackbarVal.snackbar = true;
        
        this.confirmModel = false;
        this.dialog2 = false;
      });
    },

    close(res) {
      if(res.status == 'back')
      {
        this.yesForm = false;
        location.reload();
      }
      else
      {
        let $this = this;
        if (res.status == 1) {
          this.yesForm = false;
          this.SnackbarVal.color = "success"
          this.SnackbarVal.message = res.message;
          this.SnackbarVal.snackbar = true;

          setTimeout(() => {
            location.reload();
          }, 5000); 
        }        
      }


    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/project_info/bip/dataTable.vue